/** @format */

import VoucherActionTypes from './voucher.types';

const INITIAL_STATE = {
  voucherDate: '',
  voucherInvSegKeys: [],
  voucherBatchCustomers: [],
  voucherSelectedKeys: [],
  voucherSelectedCustomers: [],
  voucherEmailStatus: [],
  isSending: false,
  isFetching: false,
  errorMessage: '',
};

const voucherReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case VoucherActionTypes.SET_VOUCHER_DATE:
      return {
        ...state,
        voucherDate: action.payload,
        voucherSelectedKeys: [],
        voucherSelectedCustomers: [],
        voucherBatchCustomers: [],
        voucherInvSegKeys: [],
        isFetching: true,
      };
    case VoucherActionTypes.FETCH_VOUCHER_INV_SEG_KEY_START:
      return {
        ...state,
        isFetching: true,
      };
    case VoucherActionTypes.FETCH_VOUCHER_INV_SEG_KEY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        voucherInvSegKeys: action.payload,
      };
    case VoucherActionTypes.FETCH_VOUCHER_INV_SEG_KEY_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      };
    case VoucherActionTypes.FETCH_VOUCHER_BATCH_CUSTOMERS_START:
      return {
        ...state,
        isFetching: true,
      };
    case VoucherActionTypes.FETCH_VOUCHER_BATCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        voucherBatchCustomers: action.payload,
      };
    case VoucherActionTypes.FETCH_VOUCHER_BATCH_CUSTOMERS_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      };
    case VoucherActionTypes.SEND_VOUCHER_EMAIL_START:
      return {
        ...state,
        isSending: true,
      };
    case VoucherActionTypes.SEND_VOUCHER_EMAIL_SUCCESS:
      return {
        ...state,
        isSending: false,
        voucherEmailStatus: action.payload,
      };
    case VoucherActionTypes.SEND_VOUCHER_EMAIL_FAILURE:
      return {
        ...state,
        isSending: false,
        errorMessage: action.payload,
      };

    case VoucherActionTypes.SET_VOUCHER_SELECTED_KEYS:
      return {
        ...state,
        voucherSelectedKeys: action.payload,
      };
    case VoucherActionTypes.SET_VOUCHER_SELECTED_CUSTOMERS:
      return {
        ...state,
        voucherSelectedCustomers: action.payload.filter((customers) => {
          return state.voucherSelectedKeys.includes(
            customers.voucherIssuanceId
          );
        }),
      };

    default:
      return state;
  }
};

export default voucherReducer;
